import Vue from 'vue'
// markdown
import VMdPreview from '@kangc/v-md-editor/lib/preview.js'
import '@kangc/v-md-editor/lib/style/preview.css'
// markdown 主题
import vuepress from '@kangc/v-md-editor/lib/theme/vuepress.js'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
import emoji from '@kangc/v-md-editor/lib/plugins/emoji/index'
import '@kangc/v-md-editor/lib/plugins/emoji/emoji.css'
import VueViewer, { directive as viewerDirective } from 'v-viewer'
import 'viewerjs/dist/viewer.css'

VMdPreview.use(vuepress)
VMdPreview.use(emoji)

// md 插件
Vue.use(VMdPreview)

/// 图片放大插件
Vue.use(VueViewer, {
	defaultOptions: {
		zIndex: 20000,
		backdrop: true,
		navbar: false,
		scalable: false,
		rotatable: false
	}
})

Vue.directive(
	'viewer',
	viewerDirective({
		debug: true
	})
)
